/**
 * Import vendor modules
 */

/**
 * Import additional modules here:
 *
 * import './module_xyz';
 */
import Nav from './nav';
import LazyLoad from './lazyload';
import TestimonialsSwiper from "./swiper";
import Accordion from "./accordion";


/**
 * Main App module used in index.js to initialise all other modules, includes helper functions/modules for use in initialising
 * modules depending on various criteria
 *
 * @returns {{init: init}}
 */
export default (() => {
    /**
     * @param Module {Object}
     * @param Module.init {Function}
     * @param name {string|boolean}
     * @param options {Object}
     */
    const alwaysInit = ( Module, name = false, options = false ) => {
        if ( name ) {
            loadedModules[ name ] = Module
        }
        Module.init( options )
    }

    const init = () => {
        /**
         * Initialise other modules here, check for prefer reduced motion for animations, etc
         **
         * Only initialise a module when screen width criteria is met:
         * Module name is: IntersectionLazyLoad
         * initialiseInBreakpoint([200, 700], IntersectionLazyLoad); // Between 200px and 700px
         * initialiseInBreakpoint([768, false], IntersectionLazyLoad); // Greater than 768px
         * initialiseInBreakpoint([false, 967], IntersectionLazyLoad); // Less than 967px
         **
         * Only initialise a module if prefers reduced motion isn't set (user hasn't requested no animation)
         * Module name is: AnimateElements
         * initialiseIfAnimationAllowed(AnimateElements);
         */

        // focusWithin(document, { force: true });
        alwaysInit( Nav )
        alwaysInit( LazyLoad )
        alwaysInit( TestimonialsSwiper )
        alwaysInit( Accordion )
    }

    return {
        init,
    }
})()
